import { useEffect, useState } from 'react';
import { toast } from 'material-react-toastify';
import { Box, Typography } from '@mui/material';
import { PaginatedResponse } from '../../interfaces/PaginatedResponse';
import { HepsiburadaOrder } from '../../interfaces/Hepsiburada/HepsiburadaOrder';
import {
  getDefaultHepsiburadaOrderFilter,
  HepsiburadaOrderFilter,
} from '../../interfaces/Hepsiburada/HepsiburadaOrderFilter';
import { getHepsiburadaOrders } from '../../api/Hepsiburada';
import { Pagination } from '../../interfaces/Pagination';
import { sharedStyles } from '../../utils/Style';
import { Waiting } from '../../components/Waiting/Waiting';
import { HepsiburadaOrdersTable } from './HepsiburadaOrdersTable/HepsiburadaOrdersTable';

export const HepsiburadaOrdersPage = () => {
  const [orders, setOrders] = useState<PaginatedResponse<HepsiburadaOrder>>({
    data: [],
    totalCount: 0,
  });
  const [filter, setFilter] = useState(getDefaultHepsiburadaOrderFilter());
  const [loading, setLoading] = useState(false);

  const refreshOrders = (filters?: HepsiburadaOrderFilter) => {
    setLoading(true);
    getHepsiburadaOrders(filters ?? filter)
      .then((res) => setOrders(res))
      .catch((err) => toast.error(err.message))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    refreshOrders();
  }, []);

  const handlePagination = (p: Pagination) => {
    const newFilter = { ...filter, pagination: p };

    setFilter(newFilter);
    refreshOrders(newFilter);
  };

  return (
    <Box sx={{ ...sharedStyles.pageBody }}>
      <Waiting open={loading} />

      <Typography variant='h5' sx={{ ...sharedStyles.pageTitle }}>
        Hepsiburada Siparişleri
      </Typography>

      <HepsiburadaOrdersTable
        orders={orders.data}
        totalCount={orders.totalCount}
        pagination={filter.pagination}
        onPagination={handlePagination}
      />
    </Box>
  );
};
